module.exports = __webpack_public_path__ + "static/unicorn.873fbf2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/unicorn.jpg
// module id = 114
// module chunks = 35783957827783 272377795509025